import { BYTES_FILE_SIZE_MAP } from 'src/constants/file-sizes';
import { getTheme } from 'src/utils/get-theme';

import { ASSETS_BASE_URL } from '../api/concierge';

const ATTACHMENT_MAX_SIZE_MB = 4;

const { isHosTheme } = getTheme();

export const appConfig = {
    env: process.env.REACT_APP_ENV,

    sentry: {
        enabled: process.env.REACT_APP_SENTRY_ENABLED === 'true',
        dsn: process.env.REACT_APP_SENTRY_DSN,
    },

    liveChat: {
        enabled: process.env.REACT_APP_LIVE_CHAT_ENABLE === 'true',
        remoteConfig: process.env.REACT_APP_LIVE_CHAT_REMOTE_CONFIG,
    },

    ga: {
        enabled: process.env.REACT_APP_GA_ENABLE === 'true',
        id: process.env.REACT_APP_GA_ID,
    },

    firebase: {
        core: {
            apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
            authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
            projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
            storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
            messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
            appId: process.env.REACT_APP_FIREBASE_APP_ID,
            measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
        },

        messaging: {
            enabled: process.env.REACT_APP_FIREBASE_MESSAGING_ENABLED === 'true',
            senderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
            webPushCertificateKey: process.env.REACT_APP_FIREBASE_WEB_PUSH_CERTIFICATE_KEY,
        },
    },

    bookingsOverview: {
        onTrackGap: 7, // date gap that splits "upcoming" type to "onTrack" or "upcoming"
    },

    contacts: {
        whatsappPhoneNumber: '+44 7779 402010',
        whatsappUrl: 'https://wa.me/447779402010',
        weChatId: 'VSCustomerEngagement',
        weChatUrl: 'http://weixin.qq.com/r/mp/UyPA2BLEyU_2rVa793ZB',
        customerManagement: isHosTheme
            ? 'mailto:customerengagement@houseofsocial.com'
            : 'mailto:customerengagement@vitastudent.com',
        callbackForm: 'https://vitastudent.as.me/schedule.php',
        submitRequest: isHosTheme
            ? 'https://houseofsocial-vitagroup.zendesk.com/hc/en-gb/requests/new?ticket_form_id=5659318000159'
            : 'https://vitagroup.zendesk.com/hc/en-gb/requests/new?ticket_form_id=5543408036255',
    },

    socialSpaces: {
        dailyLimit: 3,
        twoWeekLimit: 8,
        durationLimit: 3,
    },

    moveIn: {
        checkInFormURLHoS:
            'https://salesforce-eu.123formbuilder.com/form-83067/?&control3577401={bookingId}&control3577402={accountId}',
        checkInFormURL:
            'https://salesforce-eu.123formbuilder.com/form-37390/?&control3577172={bookingId}&control3577169={accountId}',
        checkOutFormURL: `https://salesforce-eu.123formbuilder.com/form-73982/?bkgid={bkgid}&accid={accid}`,
        checkOutFormURLHos: `https://salesforce-eu.123formbuilder.com/form-90598/?bkgid={bkgid}&accid={accid}`,
        calendarFromYear: 2022,
        moveOutCardImage: `${ASSETS_BASE_URL}/images/move-out-card.jpg`,
        moveOutCardImageHos:
            'https://cdn.brandfolder.io/2EZAWJN8/at/fg7hn7jtkp5j5ct3p4p6brh/HoS106_Referrals_Extended_Campaign_2000x800_myaccount__moving_out.png?width=450&height=180',
    },

    rebooking: {
        academicYear: '2027 / 28',
        transactionsURL: isHosTheme
            ? process.env.REACT_APP_REBOOKING_HOS_TRANSACTIONS_URL!
            : (process.env.REACT_APP_REBOOKING_TRANSACTIONS_URL! as string),
    },

    amendBooking: {
        url: isHosTheme
            ? process.env.REACT_APP_SELF_SERVE_AMEND_HOS_URL!
            : (process.env.REACT_APP_SELF_SERVE_AMEND_URL! as string),
    },

    attachments: {
        maxSizeMegabytes: ATTACHMENT_MAX_SIZE_MB,
        maxSizeBytes: ATTACHMENT_MAX_SIZE_MB * BYTES_FILE_SIZE_MAP.megabyte,
        maxCount: 6,
    },

    alumni: {
        linkedinLink: 'https://www.linkedin.com/groups/14215053/',
        weixinLink: 'https://mp.weixin.qq.com/s/653hZOMrHCpxJXA6UhX9oQ',
    },

    codeOfPractice: {
        codeOfPracticeURL:
            "https://www.gov.scot/publications/letting-agent-code-practice/#:~:text=Section%2046%20of%20the%20Housing,'%20and%20landlords'%20money%3B%20" as string,
    },

    supabase: {
        url: process.env.REACT_APP_SUPABASE_URL,
        anonKey: process.env.REACT_APP_SUPABASE_ANON_KEY,
        cookies: {
            accessTokenKey: process.env.REACT_APP_SUPABASE_ACCESS_TOKEN_KEY,
            refreshTokenKey: process.env.REACT_APP_SUPABASE_REFRESH_TOKEN_KEY,
            domain: process.env.REACT_APP_SUPABASE_COOKIE_DOMAIN,
            hosDomain: process.env.REACT_APP_SUPABASE_COOKIE_DOMAIN_HOS,
        },
        enabled: process.env.REACT_APP_SUPABASE_ENABLED === 'true',
    },

    concierge: {
        notifications: {
            baseUrl: process.env.REACT_APP_CONCIERGE_NOTIFICATIONS_BASE_URL,
        },
    },

    activeYear: '2025 / 26',
    upcomingYear: '2026 / 27',
    mockData: false,

    zendeskSsoEnabled: process.env.REACT_APP_ZENDESK_SSO_ENABLED === 'true',
    zendeskLiveChatSrc: {
        vs: 'https://static.zdassets.com/ekr/snippet.js?key=7c823433-159e-4ed4-a1f6-ec2b209bd86a',
        hos: 'https://static.zdassets.com/ekr/snippet.js?key=e57b5776-6ff0-4ecc-8742-79745ad89c4c',
    },
};
